<div class="accept-invite-page">
  <nz-card>
    <h1>{{ 'INVITE_ACCEPT.TITLE' | translate }}</h1>
    <p>{{ 'INVITE_ACCEPT.DESCRIPTION' | translate }}</p>

    <form nz-form [formGroup]="form" (ngSubmit)="submit()">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">{{ 'INVITE_ACCEPT.PASSWORD' | translate }}</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-input-group [nzSuffix]="passwordSuffix">
            <input nz-input [type]="showPassword ? 'text' : 'password'" formControlName="password" />
          </nz-input-group>
          <div class="password-strength-meter" *ngIf="form.get('password')?.value && !form.get('password')?.errors?.['passwordTooLong']">
            <div class="strength-bar" [ngClass]="passwordStrength"></div>
            <div class="strength-label" [ngClass]="passwordStrength">
              {{ 'SIGNUP.STRENGTH_' + passwordStrength.toUpperCase() | translate }}
            </div>
          </div>
          <div
            *ngIf="form.get('password')?.invalid && (form.get('password')?.touched || form.get('password')?.dirty)"
            class="error-text"
            [ngClass]="form.get('password')?.errors?.['passwordTooLong'] ? 'weak' : (form.get('password')?.value ? passwordStrength : 'weak')"
          >
            <ul>
              <li *ngIf="form.get('password')?.errors?.['required']">{{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}</li>
              <li *ngIf="form.get('password')?.errors?.['minlength']">{{ 'SIGNUP.PASSWORD_MIN_LENGTH' | translate }}</li>
              <li *ngIf="form.get('password')?.errors?.['passwordStrength']">{{ 'SIGNUP.PASSWORD_COMPLEXITY' | translate }}</li>
              <li *ngIf="form.get('password')?.errors?.['passwordTooLong']">{{ 'SIGNUP.PASSWORD_TOO_LONG' | translate }}</li>
              <li *ngIf="form.get('password')?.errors?.['passwordPolicyInvalid']">{{ 'SIGNUP.PASSWORD_COMPLEXITY' | translate }}</li>
            </ul>
          </div>
          <ng-template #passwordSuffix>
            <button
              nz-button
              nzType="text"
              type="button"
              (click)="toggleShowPassword()"
              [attr.aria-label]="(showPassword ? 'INVITE_ACCEPT.HIDE_PASSWORD' : 'INVITE_ACCEPT.SHOW_PASSWORD') | translate"
            >
              <span nz-icon [nzType]="showPassword ? 'eye-invisible' : 'eye'"></span>
            </button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24">{{ 'INVITE_ACCEPT.CONFIRM_PASSWORD' | translate }}</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-input-group [nzSuffix]="confirmPasswordSuffix">
            <input nz-input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
          </nz-input-group>
          <div *ngIf="form.get('confirmPassword')?.errors?.['required'] && (form.get('confirmPassword')?.touched || form.get('confirmPassword')?.dirty)" class="error-text weak">
            {{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}
          </div>
          <ng-template #confirmPasswordSuffix>
            <button
              nz-button
              nzType="text"
              type="button"
              (click)="toggleShowConfirmPassword()"
              [attr.aria-label]="(showConfirmPassword ? 'INVITE_ACCEPT.HIDE_CONFIRM_PASSWORD' : 'INVITE_ACCEPT.SHOW_CONFIRM_PASSWORD') | translate"
            >
              <span nz-icon [nzType]="showConfirmPassword ? 'eye-invisible' : 'eye'"></span>
            </button>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <div *ngIf="form.errors?.['passwordMismatch'] && (form.get('confirmPassword')?.touched || form.get('confirmPassword')?.dirty)" class="error-text weak">
        {{ 'INVITE_ACCEPT.PASSWORD_MISMATCH' | translate }}
      </div>

      <button nz-button nzType="primary" [nzLoading]="loading" [disabled]="loading" type="submit">
        {{ 'INVITE_ACCEPT.ACCEPT' | translate }}
      </button>
    </form>
  </nz-card>
</div>
